"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _utils = require("../utils");
var _staticContent = require("../staticContent");
var _constants = require("../constants");
var _useStepTrackerContext = _interopRequireDefault(require("../hooks/useStepTrackerContext"));
var _FieldWrapper = _interopRequireDefault(require("../FieldWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Even though this is a textarea field
// the value of feedback and position are the same as input field

// Util functions for validation rules
var meetsIsRequired = (value, isRequired) => isRequired ? value.trim().length > 0 : true;
var meetsMinLength = (value, minlength) => value.length >= minlength;
var meetsMaxLength = (value, maxlength) => maxlength === undefined || value.length <= maxlength;
var validate = (value, isRequired, minlength, maxlength) => {
  var isValid = true;

  // Only validate against minlength if input is not empty
  isValid = isValid && (value.trim().length === 0 || meetsMinLength(value, minlength));

  // When maxlength is provided, the length should be compared
  isValid = isValid && meetsMaxLength(value, maxlength);
  isValid = isValid && ((0, _utils.isInputNotEmpty)(value) || meetsIsRequired(value, isRequired));
  return isValid;
};
var LongAnswerField = props => {
  var {
    value = '',
    label = _staticContent.LONGANSWER_FIELD.DEFAULT_LABEL,
    hint,
    hintPosition = _constants.FIELD_HINT_POSITION.BELOW,
    clickedSubmit = false,
    onChange = (value, isValid) => {},
    // eslint-disable-line no-unused-vars,
    minlength = 0,
    maxlength,
    isRequired = false,
    language = _constants.CONTENTFUL_LOCALE.en,
    customErrorMessage = '',
    placeholder,
    inputRef = /*#__PURE__*/_react.default.createRef(),
    isReadOnly = false
  } = props;
  var [validationError, setValidationError] = (0, _react.useState)(undefined);
  var [validationFeedback, setValidationFeedback] = (0, _react.useState)(undefined);
  var [longAnswerValue, setLongAnswerValue] = (0, _react.useState)(value);
  var {
    buttonControlPressed,
    currentStepReferences
  } = (0, _useStepTrackerContext.default)();
  (0, _react.useEffect)(() => {
    onChange(value, validate(value, isRequired, minlength, maxlength));
  }, [isRequired, maxlength, minlength, onChange, value]);
  var updateValidationError = (0, _react.useCallback)(value => {
    if (customErrorMessage) {
      setValidationError(validate(value, isRequired, minlength, maxlength) ? undefined : customErrorMessage);
      setValidationFeedback(validate(value, isRequired, minlength, maxlength) ? _constants.FIELD_FEEDBACK.SUCCESS : _constants.FIELD_FEEDBACK.ERROR);
      return;
    }
    if (!meetsIsRequired(value, isRequired)) {
      setValidationError(_staticContent.LONGANSWER_FIELD.VALIDATION_ERROR_NO_INPUT[language]);
      setValidationFeedback(_constants.FIELD_FEEDBACK.ERROR);
    } else if (value.length !== 0 && !meetsMinLength(value, minlength)) {
      setValidationError("".concat(_staticContent.LONGANSWER_FIELD.VALIDATION_ERROR_STRING_TOOSHORT[language], " ").concat(minlength));
      setValidationFeedback(_constants.FIELD_FEEDBACK.ERROR);
    } else if (!meetsMaxLength(value, maxlength)) {
      setValidationError("".concat(_staticContent.LONGANSWER_FIELD.VALIDATION_ERROR_STRING_TOOLONG[language], "  ").concat(maxlength));
      setValidationFeedback(_constants.FIELD_FEEDBACK.ERROR);
    } else if ((0, _utils.isInputEmpty)(value) && !meetsIsRequired(value, isRequired)) {
      setValidationError("".concat(_staticContent.LONGANSWER_FIELD.VALIDATION_ERROR_NO_INPUT[language]));
      setValidationFeedback(_constants.FIELD_FEEDBACK.ERROR);
    } else {
      setValidationError(undefined);
      setValidationFeedback(_constants.FIELD_FEEDBACK.SUCCESS);
    }
  }, [customErrorMessage, isRequired, language, maxlength, minlength]);
  (0, _react.useEffect)(() => {
    if (clickedSubmit) {
      updateValidationError(value);
    }
  }, [clickedSubmit, updateValidationError, value]);
  (0, _react.useEffect)(() => {
    if (buttonControlPressed) {
      if ((0, _utils.isStepInput)(inputRef, currentStepReferences)) {
        updateValidationError(value);
      }
    }
  }, [buttonControlPressed, currentStepReferences, inputRef, updateValidationError, value, clickedSubmit]);
  var onFieldChange = val => {
    onChange(val, validate(val, isRequired, minlength, maxlength));
    setLongAnswerValue(val);
  };
  return /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.TextArea, {
    ref: inputRef,
    hint: hint,
    hintPosition: hintPosition,
    label: (0, _utils.formatLabel)(label, isRequired, language),
    value: longAnswerValue,
    placeholder: placeholder,
    onChange: onFieldChange,
    onBlur: e => updateValidationError(e.target.value),
    maxLength: maxlength,
    validation: validationFeedback,
    feedback: validationError,
    "data-di-mask": true,
    inactive: isReadOnly
  }));
};
LongAnswerField.propTypes = {
  label: _propTypes.default.string,
  hint: _propTypes.default.string,
  hintPosition: _propTypes.default.oneOf(['inline', 'below']),
  onChange: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  minlength: _propTypes.default.number,
  maxlength: _propTypes.default.number,
  isRequired: _propTypes.default.bool,
  language: _propTypes.default.string,
  clickedSubmit: _propTypes.default.bool,
  inputRef: _propTypes.default.object,
  customErrorMessage: _propTypes.default.string
};
var _default = exports.default = LongAnswerField;